<template>
  <div
    :style="{
      height: '600px',
      overflow: 'auto',
      display: 'flex',
      width: '100%',
    }"
    ref="pop"
    id="pop"
  >
    <div class="left" :style="{ width: '10%', 'margin-left': '8px' }">
      <ul>
        <li
          :class="[show == item.id ? 'item1' : 'item']"
          v-for="(item, index) in idList"
          :key="index"
          @click="change(item.id)"
        >
          <h-icon
            class="video-icon"
            :icon="item.icon"
            font-size="30"
            :style="{ height: '30px' }"
          ></h-icon>
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="leftz" :style="{ width: '10%' }"></div>
    <div class="right" :style="{ width: '80%', 'margin-left': '6%' }">
      <div id="one">
        <house-add
          ref="houseAddRef"
          :form="form"
          @validateCorrect="submit"
          :status="status"
        ></house-add>
      </div>
      <el-divider />
      <div id="two">
        <house-two
          @validateCorrect="submit"
          ref="houseTwoRef"
          :form="form"
          :status="status"
          :style="{ 'margin-top': '100px' }"
        ></house-two>
      </div>
      <el-divider />
      <div id="three">
        <house-three :form="form" ref="houseThreeRef"></house-three>
      </div>
      <div class="bottomCenter1"></div>
      <div class="bottomCenter" v-if="status !== 3">
        <h-button type="primary" @click="submitForm(2)">保存</h-button>
        <h-button @click="clocloseDialog">取消</h-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  onMounted,
  onUnmounted,
} from "vue";
import _ from "lodash";
import houseAdd from "./house/houseAdd";
import houseTwo from "./house/houseTwo";
import houseThree from "./house/houseThree";
export default defineComponent({
  name: "HouseComonents",
  components: { houseAdd, houseTwo, houseThree },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  // emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const pop = ref();
    const ruleFormRef = ref();
    const houseAddRef = ref(null);
    const houseTwoRef = ref(null);
    const houseThreeRef = ref(null);
    const activeName = ref("one");
    const state = reactive({
      oneTop: 0,
      towTop: 0,
      thrTop: 0,
      s: 0,
      scroll: "",
      show: "one",
      tabsVal: "0",
      oldtable: {
        1: {
          id: "0",
          title: "基本信息",
          component: "houseAdd",
          ref: houseAddRef,
        },
        2: {
          id: "1",
          title: "居住人员",
          component: "houseTwo",
          ref: houseTwoRef,
        },
        3: {
          id: "2",
          title: "水电气人员",
          component: "houseThree",
          ref: houseThreeRef,
        },
      },
      idList: [
        { name: "基本信息", id: "one", icon: "icon-shenfenzheng" },
        { name: "居住人员", id: "two", icon: "icon-invite" },
        { name: "水电气", id: "three", icon: "icon-shuidianbiaoguanli" },
      ],
      //
      defaultPassword: "kzga110",
      formVisible: false,
      passwordType: 1,
      state: {
        cph: "",
        clpp: "",
        cllx: "",
        csys: "",
        syxz: "",
        sswy: "",
        jdcsyr: "",
        lxdh: "",
      },
      ruleFormBack: {},
      options: [],
      validateCorrect: false,
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    const refData = toRefs(state);
    console.log(props.modelValue);
    // 保存表单数据
    const submitForm = (is) => {
      switch (activeName.value) {
        case "one":
          if (is === 1) {
          } else {
            houseAddRef.value && houseAddRef.value.submitOne();
          }
          break;
        case "two":
          if (is === 1) {
            houseTwoRef.value && houseTwoRef.value.userSubmit();
            submit();
          } else {
            houseTwoRef.value && houseTwoRef.value.submitTwo();
            submit();
          }
          break;
        case "three":
          houseThreeRef.value.submiThree();
          submit();
          break;
        default:
          break;
      }
      // context.emit("update:modelValue", state.formVisible);
    };
    // 监听弹框显示因此
    watchEffect(() => {
      houseTwoRef.value && houseTwoRef.value.userSubmit();
      houseThreeRef.value && houseThreeRef.value.submiThree();
    });
    watchEffect(() => {
      // console.log(" setup ~ props", props, context);
      state.formVisible = props.visible;
      context.emit("update:visible", state.formVisible);
    });
    const handleClick = (item) => {
      // console.log(" ~ handleClick ~ item", item);
      // console.log(" activeName", activeName);
    };

    // 提交
    const submit = (val) => {
      context.emit("submit");
      document.getElementById("one").scrollIntoView();
    };
    // 取消
    const clocloseDialog = (val) => {
      context.emit("close");
      document.getElementById("one").scrollIntoView();
    };
    // 位移
    const change = (id) => {
      console.log(id, 1111);
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
    };
    const scrollC = () => {
      if (document.getElementById("pop")) {
        state.oneTop = document.getElementById("one").offsetTop + 10;
        state.towTop = document.getElementById("two").offsetTop;
        state.thrTop = document.getElementById("three").offsetTop + 10;
        state.s = document.getElementById("pop").scrollTop || 0;
        const tow = JSON.stringify(state.towTop);
        if (state.s <= state.towTop - 100) {
          state.show = "one";
          console.log(state.show);
        }
        if (state.s >= Number(tow) - 100) {
          state.show = "two";
        }
        if (state.s >= state.thrTop - 100) {
          state.show = "three";
        }
      }
    };
    onUnmounted(() => {
      window.removeEventListener("scroll", scrollC);
    });
    onMounted(() => {
      window.addEventListener("scroll", scrollC, true);
    });
    return {
      ...refData,
      submitForm,
      ruleFormRef,
      houseAddRef,
      houseTwoRef,
      houseThreeRef,
      handleClick,
      activeName,
      clocloseDialog,
      submit,
      change,
      pop,
    };
  },
});
</script>
<style lang="scss" scoped>
.userForm {
  width: 100%;
  height: 100%;
}
.bottomCenter1 {
  padding-top: 16px;
  width: 793px;
  height: 50px;
}
.bottomCenter {
  position: absolute;
  display: flex;
  justify-content: center;
  border-top: 1px solid;
  border-color: #eee;
  padding-top: 16px;
  width: 793px;
  // position: fixed;
  height: 60px;
  bottom: 0px;
  background: #fff;
}
.formTitle {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  span {
    width: 3.5px;
    height: 16px;
    background-color: #5584ff;
    margin-right: 10px;
  }
}
.margLeftLabel {
  :deep(.el-form-item__content) {
    margin-left: 0 !important;
  }
}
// .right {
//   position: relative;
// }
.left {
  position: fixed;
  top: 162px;
  ul {
    .item {
      box-shadow: 0 0 2px;
      cursor: pointer;
      margin: 30px 0;
      border: solid 1px #dcdfe6;
      width: 110px;
      line-height: 50px;
      text-align: center;
      display: flex;
      flex-direction: column;
    }
    .item1 {
      box-shadow: 0 0 2px;
      color: #3a74fb;
      cursor: pointer;
      margin: 30px 0;
      border: solid 1px #3a74fb;
      border-left: solid 5px #3a74fb;
      width: 110px;
      line-height: 50px;
      text-align: center;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
